module.exports = __webpack_public_path__ + "img/top-qiwei-code.cd0ded0.png";